import { FC, useCallback } from 'react'
import classNames from 'classnames'
import { Fade } from 'react-awesome-reveal'
import { useNavigate } from 'react-router-dom'

import { Text } from '../../index'

import {
  WaterSupplyIcon,

  // VideoSystemIcon,
  // PowerSupplyIcon,
  CoolingSystemIcon,
  GroundingSystemIcon,
  VintilationSystemIcon,
} from 'assets'

import styles from './Services.module.scss'

const servicesData = [
  {
    title: 'waterSupply',
    description: 'waterSupplyDesc',
    icon: <WaterSupplyIcon className={styles.service__item__icon} />,
  },
  {
    title: 'fireSupply',
    description: 'fireSupplyDesc',
    icon: <CoolingSystemIcon className={styles.service__item__icon} />,
  },
  {
    title: 'airCooling',
    description: 'airCoolingDesc',
    icon: <VintilationSystemIcon className={styles.service__item__icon} />,
  },
  {
    title: 'grounding',
    description: 'groundingDesc',
    icon: <GroundingSystemIcon className={styles.service__item__icon} />,
  },
]

const Services: FC = () => {
  const navigate = useNavigate()

  const handleSeeAll = useCallback(() => {
    navigate('/services')
  }, [navigate])

  return (
    <div className={styles.servicesContainer}>
      <div className={classNames(styles.service__wrapper, 'container')}>
        <div className={styles.service__container}>
          <div className={styles.title__wrapper}>
            <div className={styles.service__title}>
              <Text text={'services'} className={styles.service__title_services} tagName='h2' />
            </div>
            <button className={styles.service__button} onClick={handleSeeAll}>
              <Text text={'seeAll'} />
              <span className={styles.service__button__arrow} aria-hidden />
            </button>
          </div>
          <div className={styles.service__item__wrapper}>
            {servicesData.map((item, index) => (
              <Fade key={index} className={styles.service__item} triggerOnce>
                <div className={styles.service__item__card}>
                  <div className={styles.service__item__icon__container}>{item.icon}</div>
                  <div className={styles.service__item__info__container}>
                    <Text text={item.title} className={styles.service__item__info__title} tagName='h3' />
                    <Text text={item.description} className={styles.service__item__info__description} />
                  </div>
                </div>
              </Fade>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services
